import React from 'react';
import PropTypes from 'prop-types';
import InputWithLabel from '../base/InputWithLabel/InputWithLabel';

const FillCompany = ({companyName, companyTax, onCompanyNameChanged, onCompanyTaxChanged}) => {
    return(
        <div 
            id="company-props"
            className="col-xs-12">
            <p>Wprowadź dane firmy:</p>
            <div className="col-xs-8">
                <InputWithLabel
                    id="companyNameInput"
                    label="Nazwa firmy *"
                    onChange={onCompanyNameChanged}
                    placeholder="Nazwa firmy"
                    type="text"
                    value={companyName}/>
            </div>
            <div className="col-xs-8">
                <InputWithLabel
                    id="companyTaxInput"
                    label="NIP *"
                    onChange={onCompanyTaxChanged}
                    placeholder="000-000-00-00"
                    type="text"
                    value={companyTax}/>
            </div>
        </div>
    );
};

FillCompany.propTypes = {
    companyName: PropTypes.string,
    companyTax: PropTypes.string,
    onCompanyNameChanged: PropTypes.func,
    onCompanyTaxChanged: PropTypes.func
};

export default FillCompany;


// WEBPACK FOOTER //
// ./src/components/Customer/FillCompany.js